/* eslint react/prop-types: "off" */

import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import root from 'window-or-global';
import { scrollToElement } from 'animations/Animations';
import { ScrollReceiver } from 'organism-react-scroll-nav';
import { reaction } from 'mobx';
import { Bind } from 'lodash-decorators';
import { NAV_HEIGHT } from 'common/consts/navigation';
import styled from 'styled-components';
import { media } from 'designsystem';
import ProductSectionParser from '../../pages/Product/ProductsSectionParser';
import StyledScrollSpy from './StyledScrollSpy';

const ScrollToElement = styled.div`
  ${media.desktop`
    position: relative;
    top: ${-NAV_HEIGHT}px;
  `}
`;

@inject('navigationStore', 'windowStore')
@observer
class PageContent extends Component {
  navigators = {};

  componentDidMount() {
    const {
      windowStore,
    } = this.props;

    this.resetHashNavigators();
    this.disposeScrollYReaction = reaction(() => windowStore.scrollY,
      this.onScrollY, { delay: 200 });
  }

  componentDidUpdate() {
    this.resetHashNavigators();
  }

  componentWillUnmount() {
    clearTimeout(this.hashTimeout);
    this.disposeScrollYReaction();
  }

  @Bind
  onScrollY() {
    clearTimeout(this.hashTimeout);
    this.hashTimeout = setTimeout(() => {
      Object.keys(this.navigators).forEach((scrollHash) => {
        if (this.navigators[scrollHash].scrollReceiver
          && this.navigators[scrollHash].scrollReceiver.current
          && this.navigators[scrollHash].scrollReceiver.current.state.active) {
          root.location.hash = scrollHash;
        }
      });
    }, 200);
  }

  @Bind
  resetHashNavigators() {
    const scrollHash = root.location.hash.replace('#', '').toLowerCase();
    if (this.navigators[scrollHash]
      && this.navigators[scrollHash].scrollToElement.current) {
      scrollToElement(this.navigators[scrollHash].scrollToElement.current, 100, 'auto');
    }
  }

  render() {
    const {
      parsedStructure,
      navigationStore,
      windowStore,
      } = this.props;

      const contactForm = parsedStructure.find(x => x.models.some(z => z.system.id === 'bdf9ea8b-e4fc-4160-8a8c-5c2ad966401c'));
      if (contactForm)
      {
          contactForm.models = contactForm.models.filter(x => x.system.id !== 'bdf9ea8b-e4fc-4160-8a8c-5c2ad966401c');
      }

    this.navigators = {};
    parsedStructure.forEach((section) => {
      if (section.sectionName) {
        this.navigators[section.sectionName.toLowerCase()] = {};
        this.navigators[section.sectionName.toLowerCase()].scrollToElement = React.createRef();
        this.navigators[section.sectionName.toLowerCase()].scrollReceiver = React.createRef();
      }
    });

    return (parsedStructure.map((section, sectionIndex) => (
      <React.Fragment key={sectionIndex}>
        <ScrollReceiver
          scrollMargin={(windowStore.isOnTablet ? 0 : NAV_HEIGHT)}
          targetId={`scroll-${sectionIndex + 1}`}
          ref={
            section.sectionName
            && this.navigators[section.sectionName.toLowerCase()].scrollReceiver
          }
        />
        <StyledScrollSpy
          top={sectionIndex === 0 ? 'top' : ''}
          mobileopen={windowStore.isOnTablet && navigationStore.isMobileNavOpen ? 'open' : ''}
          key={`navContent-${sectionIndex + 1}`}
          id={`scroll-${sectionIndex + 1}`}

        >
          <ScrollToElement
            innerRef={
              section.sectionName
              && this.navigators[section.sectionName.toLowerCase()].scrollToElement
            }
          />
          {/* the actual page content: */}
          {section.models.map(model => ProductSectionParser(model))}
        </StyledScrollSpy>
      </React.Fragment>
    ))
    );
  }
}

export default PageContent;



// WEBPACK FOOTER //
// ./src/blocks/PageContent/index.jsx